module.exports = __webpack_public_path__ + "static/media/img_man_annimation5.f8f76b60.gif";